/*
 * @Date: 2022-07-05 20:01:39
 * @LastEditors: chuhongguang
 * @desc: 关于我们
 */
import DefaultLayout from '@/layout/index'

const baseLangKey = 'layout.headerBar';

export default   {
  path: '/about',
  redirect: '/about/company-profile',
  component: DefaultLayout,
  name: 'about',
  children: (pre => [
    {
      path: 'company-profile',
      name: `${pre}companyProfile`,
      meta: {
        title: '公司简介',
        langKey: baseLangKey + '.companyProfile'
      },
      component: () => import('@/views/about/company-profile/index.vue')
    },
    {
      path: 'management',
      name: `${pre}management`,
      meta: {
        title: '管理层成员',
        langKey: baseLangKey + '.management'
      },
      component: () => import('@/views/about/management/index.vue')
    },
    {
      path: 'management/detail',
      name: `${pre}managementDetail`,
      meta: {
        title: '管理层成员',
        langKey: baseLangKey + '.management',
        hash: "subTitle"
      },
      component: () => import('@/views/about/management/managementDetail.vue')
    },
    {
      path: 'corporate-governance',
      name: `${pre}corporateGovernance`,
      meta: {
        title: '公司治理',
        langKey: baseLangKey + '.corporateGovernance'
      },
      component: () => import('@/views/about/corporate-governance/index.vue')
    },
    {
      path: 'ir-network',
      name: `${pre}irNetwork`,
      meta: {
        title: '投资者关系网',
        langKey: baseLangKey + '.irNetwork'
      },
      component: () => import('@/views/about/ir-network/index.vue')
    },
  ])('about-')
}